if (!customElements.get('ss-image-gallery-text')) {
  customElements.define('ss-image-gallery-text', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mobileLayout !== 'slider') return;

      this.rail = this.querySelector('[data-ss-rail]');
      this.dotsEl = this.querySelector('[data-ss-dots]');
      if (!this.rail || !this.dotsEl) return;

      this.slides = Array.from(this.rail.children);
      if (this.slides.length < 2) return;

      this.onScroll = SS.rafThrottle(this.update.bind(this));

      this.cleanup = [
        SS.onBreakpoint(
          `(max-width: ${SS.bp.desktop - 1}px)`,
          () => this.enable(),
          () => this.disable()
        )
      ];
    }

    disconnectedCallback() {
      this.disable();
      this.cleanup?.forEach((fn) => fn());
    }

    enable() {
      if (this.active) return;
      this.active = true;

      this.dotsEl.innerHTML = '';
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ss-igt__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Image ${i + 1} sur ${this.slides.length}`);
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsEl.appendChild(dot);
      });

      this.dots = Array.from(this.dotsEl.children);
      this.dotsEl.removeAttribute('hidden');
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disable() {
      if (!this.active) return;
      this.active = false;

      this.rail.removeEventListener('scroll', this.onScroll);
      this.dotsEl.setAttribute('hidden', '');
      this.dotsEl.innerHTML = '';
      this.dots = [];
    }

    currentIndex() {
      const center = this.rail.scrollLeft + this.rail.clientWidth / 2;
      let best = 0;
      let min = Infinity;

      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (dist < min) { min = dist; best = i; }
      });
      return best;
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.rail.scrollTo({
        left: slide.offsetLeft,
        behavior: SS.reduceMotion() ? 'auto' : 'smooth'
      });
    }

    update() {
      const index = this.currentIndex();
      this.dots?.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }
  });
}